module.exports = __webpack_public_path__ + "static/assets/6a5190e0f6ec0a3f88740404247a1610.svg";